import Logo from '@hiredigital/ui/Logo';
import ScheduleACall from '@components/Registration/ScheduleACall';
import BaseLayout from '@components/Layout/BaseLayout';
import Hero from '@components/PageComponents/Hero/Hero';
import Link from '@components/Link';
import LogoSection from '@components/PageComponents/LogoSection/LogoSection';

import Styles from './Styles.module.scss';

const EnterpriseRegisterPage = ({ ...props }) => {
  const pageHead = {
    title: `Schedule a Call | Hire Digital`,
    meta: [
      {
        name: 'description',
        content: `Scale your marketing, creative and digital initiatives with Hire Digital's exclusive talent network. Rigorously screened for your most important projects.`,
      },
    ],
  };
  const canonicalUrl = `${process.env.NEXT_PUBLIC_CANONICAL_URL}/schedule-call`;

  return (
    <BaseLayout
      canonicalUrl={canonicalUrl}
      pageHead={pageHead}
      removeMetaImage
      removeMetaSocial
      removeMetaJsonLd>
      <div className={Styles.container}>
        <Hero parent={Hero.Page.LOGIN} square={true}>
          <div className={Styles.topFormSection}>
            <div style={{ margin: '50px 0px 0 0px' }}>
              <Link href='/' className={Styles.logoContainer}>
                <Logo className={Styles.logo} type={Logo.Type.WHITE} site={'3'} />
              </Link>
              <ScheduleACall />
            </div>
          </div>

          <LogoSection removeBackground />
        </Hero>
      </div>
    </BaseLayout>
  );
};

export default EnterpriseRegisterPage;
